import { c as _c } from "react/compiler-runtime";
import IconArrow from '@/components/assets/icon_arrow_down.svg';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
interface ShowReplyToggleProps {
  toggleReplies: () => void;
  showReplies: boolean;
  replyCount: number;
}
export const ShowReplyToggle = t0 => {
  const $ = _c(12);
  const {
    toggleReplies,
    showReplies,
    replyCount
  } = t0;
  const t = useTranslations();
  const t1 = showReplies && "rotate-x-180";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("[&>path]:fill-vive-brand-50 group-hover:[&>path]:fill-vive-brand-40 200", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <IconArrow className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("comment-thread.replies");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `${replyCount} ${t4}`;
  let t6;
  if ($[6] !== t5) {
    t6 = <p className="body-2-omni-styles text-vive-brand-50 group-hover:text-vive-brand-40">{t5}</p>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6 || $[10] !== toggleReplies) {
    t7 = <div className="group flex cursor-pointer items-center gap-1 px-2 py-1.5" onClick={toggleReplies}>{t3}{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = toggleReplies;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export const ShowMoreReplies = t0 => {
  const $ = _c(8);
  const {
    loadMore
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconArrow className="[&>path]:fill-vive-brand-50 group-hover:[&>path]:fill-vive-brand-40 200" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("comment-reply.more-replies");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="body-2-omni-styles text-vive-brand-50 group-hover:text-vive-brand-40">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== loadMore || $[6] !== t3) {
    t4 = <div className="group mt-2 ml-10.5 flex cursor-pointer items-center gap-1 px-2 py-1 md:ml-16" onClick={loadMore}>{t1}{t3}</div>;
    $[5] = loadMore;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};